/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Advantage_NewslettersInputs */

const en_why_listening_advantage_newsletters = /** @type {(inputs: Why_Listening_Advantage_NewslettersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reads your newsletters`)
};

const es_why_listening_advantage_newsletters = /** @type {(inputs: Why_Listening_Advantage_NewslettersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lee tus newsletters`)
};

/**
* | output |
* | --- |
* | "Reads your newsletters" |
*
* @param {Why_Listening_Advantage_NewslettersInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_advantage_newsletters = /** @type {((inputs?: Why_Listening_Advantage_NewslettersInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Advantage_NewslettersInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_advantage_newsletters(inputs)
	return en_why_listening_advantage_newsletters(inputs)
});